import { AxiosRequestConfig } from 'axios';

import { httpInstance } from './http.instance';

const getRequest = async <T>(url: string, config?: AxiosRequestConfig) => {
  try {
    return await httpInstance.get<T>(url, { ...config });
  } catch (e: any) {
    // console.log(e,   'Error in getRequest');
    throw e.response?.data;
  }
};

const postRequest = async <T, K>(
  url: string,
  data: K,
  config?: AxiosRequestConfig
) => {
  try {
    return await httpInstance.post<T>(url, data, config);
  } catch (e: any) {
    throw e.response?.data;
  }
};

const putRequest = async <T, K>(
  url: string,
  data: K,
  _config?: AxiosRequestConfig
) => {
  try {
    return await httpInstance.put<T>(url, data);
  } catch (e: any) {
    throw e.response?.data;
  }
};

const patchRequest = async <T, K>(
  url: string,
  data: K,
  _config?: AxiosRequestConfig
) => {
  try {
    return await httpInstance.patch<T>(url, data);
  } catch (e: any) {
    throw e.response?.data;
  }
};

const deleteRequest = async <T>(url: string) => {
  try {
    return await httpInstance<T>({ method: 'DELETE', url });
  } catch (e: any) {
    throw e.response?.data;
  }
};

export { getRequest, postRequest, putRequest, deleteRequest, patchRequest };
